var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconButtonRemove(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3381_1508",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 8,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 8,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3381_1508)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15 29C14.45 29 13.9792 28.8042 13.5875 28.4125C13.1958 28.0208 13 27.55 13 27V14C12.7167 14 12.4792 13.9042 12.2875 13.7125C12.0958 13.5208 12 13.2833 12 13C12 12.7167 12.0958 12.4792 12.2875 12.2875C12.4792 12.0958 12.7167 12 13 12H17C17 11.7167 17.0958 11.4792 17.2875 11.2875C17.4792 11.0958 17.7167 11 18 11H22C22.2833 11 22.5208 11.0958 22.7125 11.2875C22.9042 11.4792 23 11.7167 23 12H27C27.2833 12 27.5208 12.0958 27.7125 12.2875C27.9042 12.4792 28 12.7167 28 13C28 13.2833 27.9042 13.5208 27.7125 13.7125C27.5208 13.9042 27.2833 14 27 14V27C27 27.55 26.8042 28.0208 26.4125 28.4125C26.0208 28.8042 25.55 29 25 29H15ZM15 14V27H25V14H15ZM17 24C17 24.2833 17.0958 24.5208 17.2875 24.7125C17.4792 24.9042 17.7167 25 18 25C18.2833 25 18.5208 24.9042 18.7125 24.7125C18.9042 24.5208 19 24.2833 19 24V17C19 16.7167 18.9042 16.4792 18.7125 16.2875C18.5208 16.0958 18.2833 16 18 16C17.7167 16 17.4792 16.0958 17.2875 16.2875C17.0958 16.4792 17 16.7167 17 17V24ZM21 24C21 24.2833 21.0958 24.5208 21.2875 24.7125C21.4792 24.9042 21.7167 25 22 25C22.2833 25 22.5208 24.9042 22.7125 24.7125C22.9042 24.5208 23 24.2833 23 24V17C23 16.7167 22.9042 16.4792 22.7125 16.2875C22.5208 16.0958 22.2833 16 22 16C21.7167 16 21.4792 16.0958 21.2875 16.2875C21.0958 16.4792 21 16.7167 21 17V24Z",
    fill: "#CC0030"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconButtonRemove);
export default __webpack_public_path__ + "static/media/IconButtonRemove.34483353082dd7ca654d893edf7f5d08.svg";
export { ForwardRef as ReactComponent };